import parse from 'html-react-parser'
class ActionProvider {
    constructor(createChatBotMessage, setStateFunc) {
      this.createChatBotMessage = createChatBotMessage;
      this.setState = setStateFunc;
    }
    
    greet() {
        // const greetingMessage = this.createChatBotMessage('Hi, friend.');
        // this.updateChatbotState(greetingMessage);

        const greetingMessage = this.createChatBotMessage('Bonjour! Vous pouvez utiliser cet outil pour vous aider à trouver des réponses à vos questions sur les produits et services INTERAC.');
        this.updateChatbotState(greetingMessage);
    }

    careers() {
      const careersMessage = this.createChatBotMessage(parse('Propulsez-vous vers l’avenir grâce à une carrière à Interac. <a href="https://www.interac.ca/fr/a-propos/carrieres/">Renseignez-vous sur les offres d’emploi.</a>'));
      this.updateChatbotState(careersMessage);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    }

    contactUs() {
      const contactUs = this.createChatBotMessage(parse('Visit our <a href="https://www.interac.ca/en/contact-us/">contact us</a> page for details.'));
      this.updateChatbotState(contactUs);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    }


    WhatIseTransfer() {
      const WhatIseTransferMessage = this.createChatBotMessage(parse('Le service Virement <em>Interac</em> est un moyen rapide, sécuritaire et pratique d’envoyer de l’argent à toute personne vivant au Canada à l’aide des services bancaires en ligne. La banque ou coopérative de crédit participante vire les fonds en suivant des procédures bancaires sécuritaires bien établies. Les virements sont immédiats, mais peuvent prendre jusqu’à 30 minutes selon votre banque ou coopérative de crédit. Visitez notre page Virement <em>Interac</em> pour obtenir des instructions détaillées sur son fonctionnement.'));
      this.updateChatbotState(WhatIseTransferMessage);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    }

  eTransferContact() {
    const eTransferContactMessage = this.createChatBotMessage(parse('Please contact your bank or credit union to troubleshoot any transactions in progress. The contact information is usually on the back of your <em>Interac</em> debit card. You can also use this <em>Interac</em> e-Transfer form.'));
    this.updateChatbotState(eTransferContactMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  eTransferHowToSend() {
    const eTransferHowToSend = this.createChatBotMessage(parse('Les étapes exactes varient selon les banques ou coopératives de crédit, mais le processus sera toujours simple. Il suffit d’ouvrir une session dans votre compte bancaire en ligne, de naviguer jusqu’à la section Virement Interac et de suivre les instructions.'));
    this.updateChatbotState(eTransferHowToSend);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  eTransferHowToCancel() {
    const eTransferHowToCancel = this.createChatBotMessage(parse('Pour annuler un virement, ouvrez une session dans votre compte bancaire en ligne. Repérez la transaction ou consultez l’historique des paiements, puis sélectionnez la transaction de Virement Interac que vous souhaitez annuler. Utilisez l’option d’annulation. Ce processus varie selon les institutions financières, qui peuvent aussi exiger des frais d’annulation. Communiquez avec votre banque ou coopérative de crédit pour obtenir de plus amples renseignements.'));
    this.updateChatbotState(eTransferHowToCancel);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  HowToDeposit() {
    const HowToDepositMessage = this.createChatBotMessage(parse('When someone sends you money via <em>Interac</em> e-Transfer, you will receive an email or text message that a transfer has been sent to you. The notification includes information such as Sender\'s name, Transfer amount A link to deposit your transfer to your bank account. The fastest way to get your funds is through your financial institution’s online or mobile banking service. Simply click the link in the notification, select your bank or credit union, login to online or mobile banking and deposit the money into the account of your choice. If you cannot click on the link, either cut and paste or type the link into your browser. You will be prompted to enter the answer to a security question set by the sender, as part of the secure login process. Alternatively, Autodeposit is an <em>Interac</em> e-Transfer feature that allows users to register to have incoming <em>Interac</em> e–Transfer funds deposited directly into their bank account – no security question and answer needed. Learn more about <em>Interac</em> e-Transfer enhanced features below.'));
    this.updateChatbotState(HowToDepositMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  HowToSecureEtransfer() {
    const HowToSecureEtransferMessage = this.createChatBotMessage('You are not sending money by email or text message: Only the notification travels over the Internet to advise the recipient that the transfer has been initiated and to provide instructions on how to deposit the money. The money always resides safely at a financial institution and is transferred through existing payment networks that banks and credit unions have used for years to settle cheques, bank machine deposits and withdrawals. Security measures have been built into the system, including: Encryption technology, Confidential user IDs and passwords issued by financial institutions, Secure login process, A security question and answer to ensure only the intended recipient receives the money, 128-bit browser encryption.');
    this.updateChatbotState(HowToSecureEtransferMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferCost() {
    const etransferCostMessage = this.createChatBotMessage(parse('There may be a fee from your financial institution for using the <em>Interac</em> e-Transfer service. Please check with your bank or credit union directly.'));
    this.updateChatbotState(etransferCostMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferLimit() {
    const etransferLimitMessage = this.createChatBotMessage('Like most financial transactions, there are limits on the amount you can send. Each financial institution sets their own. Please contact your bank or credit union for details.');
    this.updateChatbotState(etransferLimitMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferStopTxt() {
    const etransferStopTxtMessage = this.createChatBotMessage(parse('You received a text notification because the sender selected “text message” to send you money via <em>Interac</em> e-Transfer. We recommend you provide the sender with your email address instead for sending. To permanently stop all text notifications from <em>Interac</em> e-Transfer, reply to an <em>Interac</em> e-Transfer text with the message STOP (or text STOP to 100001). Please note: Once stopped, text message notifications cannot be reinstated for all transactions moving forward. Standard text messaging rates apply.'));
    this.updateChatbotState(etransferStopTxtMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  etransferNonCanadian() {
    const etransferNonCanadianMessage = this.createChatBotMessage('If you have received an <em>Interac</em> e-Transfer and do not have an account with a participating Canadian bank, ask your sender to cancel the transfer. Once the transfer is cancelled, the funds will be returned to the sender’s account. If you are unable to contact your sender, the transfer will expire in approximately 30 days. Once the transfer expires, the money is automatically deposited into the sender’s account.');
    this.updateChatbotState(etransferNonCanadianMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferNoBank() {
    const etransferNoBankMessage = this.createChatBotMessage(parse('If your bank or credit union doesn’t offer <em>Interac</em> e-Transfer, you cannot receive funds. Please contact your bank or financial institution for additional information.'));
    this.updateChatbotState(etransferNoBankMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  etransferSecurityQA() {
    const etransferSecurityQAMessage = this.createChatBotMessage(parse('If you don’t know the answer to the security question, contact the sender. If you answer the security question incorrectly more than three times, the <em>Interac</em> e-Transfer transaction will automatically cancel.'));
    this.updateChatbotState(etransferSecurityQAMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  whatisAutodeposit() {
    const whatisAutodeposit = this.createChatBotMessage(parse('Autodeposit is an <em>Interac</em> e-Transfer feature that allows users to register to have incoming <em>Interac</em> e–Transfer funds deposited directly into their bank account – no security question and answer needed. <a href="https://www.interac.ca/en/consumers/products/interac-e-transfer/enhanced-features/#fi-list-autodeposit" target="_blank">Click here</a> for a list of participating banks and credit unions, and to learn more about the <em>Interac</em> e-Transfer Autodeposit feature.'));
    this.updateChatbotState(whatisAutodeposit);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  DebitWorks() {
    const DebitWorksMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit and <em>Interac</em> Contactless transactions are approved by your bank or credit union through secure online systems in real-time. Transactions appear instantly on your bank account records, allowing you to monitor your available balance so you can keep track of your spending.'));
    this.updateChatbotState(DebitWorksMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  DebitSecurity() {
    const DebitSecurityMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit and <em>Interac</em> Flash are extremely secure forms of payment with sophisticated safeguards and fraud detection tools in place to protect you: <em>Interac</em> debit cards use EMV secure chip processing to store and process data securely. This makes it next to impossible to create counterfeit cards and protects you against fraud tactics such as skimming, transaction replay and electronic pickpocketing. When you use <em>Interac</em> Debit on your mobile device, you enjoy the same security features as your <em>Interac</em> debit card, as well as your device’s standard security measures such as passcode or biometric ID verification. Transaction limits are set at $100 per transaction.  There is also added protection of a cumulative contactless limit set by individual banks or credit unions.  A cumulative limit is the maximum contactless spend limit that can be done by an individual <em>Interac</em> debit card before the user is promoted to reset the limit with a Chip and PIN transaction. This confirms that you are the authorized cardholder. You are also protected from any losses due to unauthorized transactions under the <em>Interac</em> Zero Liability Policy. If your card is lost or stolen, contact your bank or credit union right away.'));
    this.updateChatbotState(DebitSecurityMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  ApplePayDebit() {
    const ApplePayDebitMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit on Apple Pay is a new way to make debit payments using <em>Interac</em> Debit on your eligible Apple device.<em>Interac</em> Debit for In-App & In-Browser payments is the easy, fast, and secure way for Canadians to pay directly from their bank account when shopping online using their mobile device. An in-app payment takes place within the merchant’s native mobile app. An in-browser payment takes place within a supported mobile browser (i.e Safari).'));
    this.updateChatbotState(ApplePayDebitMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  ApplePay() {
    const ApplePayMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit cardholders with a debit card issued from participating financial institutions can use <em>Interac</em> Debit to pay with Apple Pay at merchants who accept <em>Interac</em> Flash contactless payments. For in-app and in-browser transactions, <em>Interac</em> debit cardholders with a debit card issued from participating financial institutions can pay on select merchant applications or mobile websites using Apple Pay. We are continuously working to onboard more issuers and merchants to support in-app and in-browser with <em>Interac</em> Debit.'));
    this.updateChatbotState(ApplePayMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  requestMoney() {
    const requestMoneyMessage = this.createChatBotMessage(parse('Request Money is a feature that allows you to send a request for funds via the <em>Interac</em> e-Transfer system. To learn more about <em>Interac</em> e-Transfer, click here. Once the request is fulfilled and the funds are available in your account, you will receive a notification via text or email.'));
    this.updateChatbotState(requestMoneyMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  tryAgain() {
    const tryAgainMessage = this.createChatBotMessage(parse('Désolé, je suis encore en apprentissage et je n’ai pas compris votre question. Essayez d\'utiliser différents mots clés ou <a href="https://www.interac.ca/fr/contactez-nous/" target="_blank">contactez-nous</a> pour obtenir de l\'aide'));
    this.updateChatbotState(tryAgainMessage);
  }


  moreQuestions () {
    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
      {
        widget: 'learningOptions',
      }
    );
    this.updateChatbotState(moreQuestionsMessage);
  }

  handleGreet = () => {
    const message = this.createChatBotMessage(
      'Bonjour! Vous pouvez utiliser cet outil pour vous aider à trouver des réponses à vos questions sur les produits et services INTERAC.',
      {
        widget: 'learningOptions',
      }
    );

    this.updateChatbotState(message);
  };

    handleConsumerProducts = () => {
      const message = this.createChatBotMessage(
        'Au sujet de quel produit pouvons-nous vous aider?',
        {
          widget: 'ConsumerProducts',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleEtransfer = () => {
      const user_message = this.createChatBotMessage(
        parse('Virement <em>Interac</em>'),
      );
      const message = this.createChatBotMessage(
        'Au sujet de quel produit pouvons-nous vous aider?',
        {
          widget: 'EtransferOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleAutodeposit = () => {
      // window.open('https://www.interac.ca/en/consumers/products/interac-e-transfer/', '_blank');
      const user_message = this.createChatBotMessage(
        'Dépôt automatique',
      );
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'AutodespositOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };
    handleEtransfer1 = () => {
      const handleEtransfer1 = this.createChatBotMessage(parse('Oui, vous pouvez répondre au message texte ou envoyer un message au 100001. Notre système reconnaît deux réponses (les frais habituels liés à la messagerie texte s’appliquent) :<br />Tapez « Aide » dans le message texte : Vous recevrez un message texte contenant l’adresse URL du site Web interac.ca. On vous demandera de cliquer sur le lien ou de le coller dans votre navigateur.<br /> Tapez « Stop » dans le message texte :<br />Vous mettrez fin de façon permanente à tous les avis par message texte de Virement Interac. Une fois interrompu, l’envoi d’avis par message texte ne peut être rétabli.'));
      this.updateChatbotState(handleEtransfer1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer2 = () => {
      const handleEtransfer2 = this.createChatBotMessage(parse('Non. Bien que les trois modes de paiement vous permettent de payer directement avec des fonds de votre compte bancaire personnel, Virement <em>Interac</em> est un virement de fonds de votre compte vers celui d’une autre personne par voie électronique. Débit <em>Interac</em> et <em>Interac</em> en ligne utilisent un mode de paiement différent.'));
      this.updateChatbotState(handleEtransfer2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer3 = () => {
      const handleEtransfer3 = this.createChatBotMessage(parse('Exact steps vary by individual bank or credit union, but the process will always be simple. Just log into your online bank account, navigate to the <em>Interac</em> e-Transfer section and follow the instructions.'));
      this.updateChatbotState(handleEtransfer3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer4 = () => {
      const handleEtransfer4 = this.createChatBotMessage(parse('To cancel a transfer, log into your online bank account. Go to the transaction or payment history and select the <em>Interac</em> e-Transfer transaction you wish to cancel. Use the cancel option provided. This process varies by financial institution, who may also charge a cancellation fee. Contact your bank or credit union for more information.'));
      this.updateChatbotState(handleEtransfer4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer5 = () => {
      const handleEtransfer5 = this.createChatBotMessage(parse('Malheureusement, il est impossible d’annuler une transaction une fois que le dépôt a été effectué. Vous devrez prendre des dispositions directement avec le bénéficiaire. Vous devez envoyer de l’argent uniquement à vos connaissances et à des personnes dignes de confiance. Dans la plupart des cas, comme pour l’envoi d’argent à des parents et à des amis, le remboursement de dettes et les cadeaux, vous connaîtrez bien le destinataire du Virement Interac. Dans les situations où vous ne connaissez pas le destinataire, par exemple pour les achats dans le cadre d’enchères en ligne, prenez les mêmes précautions que lorsque vous faites des achats réglés en argent. Afin de protéger votre argent lorsque vous participez à des enchères ou effectuez des achats en ligne, prenez soin de lire et de suivre les étapes recommandées par les exploitants des sites Web.'));
      this.updateChatbotState(handleEtransfer5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer6 = () => {
      const handleEtransfer6 = this.createChatBotMessage(parse('Lorsqu’une personne vous envoie de l’argent par Virement <em>Interac</em>, vous recevez un courriel ou un message texte pour vous en aviser. L’avis contient des renseignements sur le virement :'));
      this.updateChatbotState(handleEtransfer6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer7 = () => {
      const handleEtransfer7 = this.createChatBotMessage(parse('Vous n’envoyez pas d’argent par courriel ni par messagerie texte. Seul l’avis est acheminé par Internet pour aviser le destinataire qu’un virement lui a été envoyé et pour lui fournir les instructions sur le dépôt des fonds. Les fonds, eux, sont toujours détenus en toute sécurité par l’institution financière de l’expéditeur. Ils sont ensuite transmis par des réseaux de paiement que les banques et coopératives de crédit utilisent depuis longtemps pour régler les chèques et traiter les dépôts et les retraits effectués aux guichets automatiques. Le système est protégé par nombre de mesures de sécurité, notamment :<ul><li>Technologie de cryptage</li><li>Codes d’utilisateur et mots de passe confidentiels émis par les institutions financières</li><li>Ouverture de session sécuritaire</li><li>Question et réponse de sécurité pour que les fonds ne parviennent qu’à leur destinataire</li><li>Cryptage à 128 bits</li></ul>'));
      this.updateChatbotState(handleEtransfer7);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleAutodeposit1 = () => {
      const handleAutodeposit1 = this.createChatBotMessage(parse('Demander des fonds est une fonction de Virement <em>Interac</em> facile à utiliser qui vous permet d’envoyer un avis à une personne pour lui demander un paiement. Il s’agit d’une façon pratique d’envoyer des factures aux clients et de s’assurer que le paiement est acheminé au bon endroit, ce qui réduit au minimum le risque que votre paiement soit perdu, retardé par la poste ou envoyé vers le mauvais compte.'));
      this.updateChatbotState(handleAutodeposit1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleAutodeposit2 = () => {
      const handleAutodeposit2 = this.createChatBotMessage(parse('Oui. La fonction Dépôt automatique offre un niveau de sécurité égal à celui du secteur bancaire, comme Virement <em>Interac</em>. Virement <em>Interac</em> est l’un des services de virement de fonds numérique les plus sécuritaires au monde. Lorsque vous envoyez ou demandez des fonds à l’aide de Virement <em>Interac</em>, l’argent est viré au moyen de procédures bancaires sécuritaires établies que les banques et coopératives de crédit utilisent depuis longtemps. Les fonds ne transitent jamais par courriel ou par message texte. Ces modes de communication ne servent qu’à vous aviser de la transaction et à vous fournir des instructions pour effectuer le dépôt.'));
      this.updateChatbotState(handleAutodeposit2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAutodeposit3 = () => {
      const handleAutodeposit3 = this.createChatBotMessage(parse('La disponibilité de la fonction Dépôt automatique, de même que la marche à suivre pour s’inscrire, varient selon les institutions financières. Pour vous inscrire à la fonction Dépôt automatique de Virement <em>Interac</em>, ouvrez une session de services bancaires en ligne ou mobiles et rendez-vous aux paramètres de votre profil Virement <em>Interac</em>. Ensuite, ajoutez l’identifiant (adresse de courriel ou message texte) que vous souhaitez associer à la fonction Dépôt automatique de Virement <em>Interac</em> et sélectionnez le compte dans lequel vous souhaitez que les fonds soient déposés. Vous recevrez une demande de vérification de l’inscription. La prochaine fois que quelqu’un enverra des fonds à l’identifiant inscrit, l’argent sera déposé directement dans votre compte bancaire sans que vous ayez à répondre à la question de sécurité.'));
      this.updateChatbotState(handleAutodeposit3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAutodeposit4 = () => {
      const handleAutodeposit4 = this.createChatBotMessage(parse('Il est possible que certaines institutions financières n’offrent pas la fonction Dépôt automatique de Virement INTERAC. Communiquez avec votre banque ou coopérative de crédit participante pour confirmer.'));
      this.updateChatbotState(handleAutodeposit4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAutodeposit5 = () => {
      const handleAutodeposit5 = this.createChatBotMessage('Si vous n’avez pas reçu le courriel de vérification de l’inscription à la fonction Dépôt automatique, consultez votre dossier de courrier indésirable. Si vous ne trouvez pas l’avis, vous devrez vous inscrire de nouveau à la fonction par l’intermédiaire des services bancaires en ligne ou de l’application de services bancaires mobiles de votre banque ou coopérative de crédit participante.');
      this.updateChatbotState(handleAutodeposit5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    
    handleRequestMoney = () => {
      //window.open('https://www.interac.ca/en/consumers/products/interac-e-transfer/enhanced-features/#interac-etransfer-request-money', '_blank');
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'RequestMoneyOptions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleRequestMoney1 = () => {
      const handleRequestMoney1 = this.createChatBotMessage(parse('Demander des fonds est une fonction de Virement Interac facile à utiliser qui vous permet d’envoyer un avis à une personne pour lui demander un paiement. Il s’agit d’une façon pratique d’envoyer des factures aux clients et de s’assurer que le paiement est acheminé au bon endroit, ce qui réduit au minimum le risque que votre paiement soit perdu, retardé par la poste ou envoyé vers le mauvais compte.'));
      this.updateChatbotState(handleRequestMoney1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleRequestMoney2 = () => {
      const handleRequestMoney2 = this.createChatBotMessage(parse('Oui, vous pouvez vous exclure de ce service à l’égard d’un demandeur précis, ou du service en entier, en sélectionnant l’option pertinente de la page d’exécution de la demande. Vous pouvez aussi vous exclure de ce service à l’égard d’un demandeur précis ou du service en entier en modifiant vos préférences par l’intermédiaire de l’application de services bancaires en ligne ou mobiles de votre institution financière. Vous n’avez qu’à vous rendre à la section des paramètres de Virement <em>Interac</em> ou à cliquer ici. Veuillez noter que la marche à suivre varie selon les institutions financières participantes.'));
      this.updateChatbotState(handleRequestMoney2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleRequestMoney3 = () => {
      const handleRequestMoney3 = this.createChatBotMessage(parse('Il est possible que votre institution financière applique des frais pour l’utilisation de la fonction Demande de fonds de Virement <em>Interac</em>. Veuillez communiquer directement avec votre banque ou coopérative de crédit.'));
      this.updateChatbotState(handleRequestMoney3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    
    handleIntlTransfersOptions = () => {
      //window.open('https://www.interac.ca/en/consumers/products/interac-e-transfer/international-money-transfer/', '_blank');
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'IntlTransfersOptions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleIntlTransfersOptions1 = () => {
      const handleIntlTransfersOptions1 = this.createChatBotMessage('Vous pouvez envoyer de l’argent dans plus de 75* pays à partir de votre compte bancaire canadien. * Le nombre varie selon l’institution financière. Pour obtenir une liste à jour des pays, veuillez communiquer avec votre institution financière.');
      this.updateChatbotState(handleIntlTransfersOptions1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleIntlTransfersOptions2 = () => {
      const handleIntlTransfersOptions2 = this.createChatBotMessage(parse('Pour envoyer de l’argent à l’étranger, il suffit de suivre quatre étapes simples :<ol><li>Ouverture d’une session dans vos services bancaires en ligne ou mobiles.</li><li>Sélection de l’envoi international de fonds, puis saisie de la destination et des renseignements bancaires du destinataire.</li><li>Traitement des demandes – votre demande sera envoyée au destinataire, et vous recevrez un avis par courriel lorsque les fonds auront été envoyés.</li><li>Exécution de la demande – les fonds sont versés directement dans le compte bancaire du destinataire.</li></ol>'));
      this.updateChatbotState(handleIntlTransfersOptions2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleIntlTransfersOptions3 = () => {
      const handleIntlTransfersOptions3 = this.createChatBotMessage('Un numéro IBAN est un numéro de compte bancaire international. Ce numéro est indispensable pour envoyer/recevoir de l’argent par virement international par l’intermédiaire de Mastercard et d’Interac.');
      this.updateChatbotState(handleIntlTransfersOptions3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleIntlTransfersOptions4 = () => {
      const handleIntlTransfersOptions4 = this.createChatBotMessage('Pour obtenir des renseignements précis, veuillez communiquer avec votre institution financière.');
      this.updateChatbotState(handleIntlTransfersOptions4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleIntlTransfersOptions5 = () => {
      const handleIntlTransfersOptions5 = this.createChatBotMessage('Le taux de change qui s’applique est le taux de change quotidien courant affiché par votre institution financière. Lorsque vous commencez le virement, vous savez exactement à quoi vous attendre : il n’y a pas de frais cachés ni de rajustement du taux de change après le début du virement. Le montant que vous voyez est le montant que vous envoyez : un seul chiffre, aucune surprise.');
      this.updateChatbotState(handleIntlTransfersOptions5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    
    handleetransferSecurity = () => {
      //window.open('https://www.interac.ca/en/consumers/security/interac-e-transfer/', '_blank');
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'EtransferSecurityOptions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleEtransferSecurityOptions1 = () => {
      const handleEtransferSecurityOptions1 = this.createChatBotMessage(parse('L’hameçonnage est une escroquerie où des fraudeurs tentent d’acquérir des renseignements personnels ou financiers, comme des mots de passe ou des numéros de carte, en se faisant passer, par l’intermédiaire de communications électroniques, pour une personne ou une entreprise digne de confiance. L’hameçonnage se fait habituellement par courriel ou message instantané, mais il arrive qu’il se fasse par téléphone. Dans certains cas, le fraudeur envoie un courriel ou un message texte (hameçonnage par SMS) d’apparence authentique semblant venir d’une entreprise légitime et demandant aux destinataires de dévoiler des renseignements personnels ou financiers qui servent par la suite à commettre une fraude. Soyez méfiant si vous recevez un avis vous ne vous n’attendiez pas indiquant que vous avez reçu de l’argent par Virement <em>Interac</em>. Communiquez avec l’expéditeur pour confirmer. Si vous ne pouvez pas confirmer, veuillez transmettre l’avis immédiatement à l’adresse <a href="mailto:phishing@interac.ca">phishing@interac.ca</a>.'));
      this.updateChatbotState(handleEtransferSecurityOptions1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleEtransferSecurityOptions2 = () => {
      const handleEtransferSecurityOptions2 = this.createChatBotMessage('Non. INTERAC n’embauche pas d’agents de transfert. Plusieurs cas de recrutement à des fins frauduleuses ont été rapportés; des chercheurs d’emploi au Canada ont notamment été embauchés comme mandataires de « sociétés étrangères ». En fait, les personnes recrutées servent d’intermédiaires pour le transfert de fonds volés à l’étranger. Toute personne qui, même à son insu, participe à un tel crime s’en fait le complice et est passible de poursuites judiciaires. Nous vous recommandons fortement de faire des vérifications complètes dans le cas de telles offres d’emploi.');
      this.updateChatbotState(handleEtransferSecurityOptions2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransferSecurityOptions3 = () => {
      const handleEtransferSecurityOptions3 = this.createChatBotMessage(parse('Habituellement, « l’employeur » se fait passer pour une entreprise légitime établie à l’étranger qui cherche un représentant au Canada sur des sites Web de recrutement. Le travail consiste à accepter les paiements de clients canadiens et de transférer les sommes à l’étranger. Comme exigence essentielle pour le poste, l’employeur veut que l’employé ait accès à un compte bancaire en ligne et puisse recevoir des fonds par Virement <em>Interac</em>. Une fois que l’employé a reçu les fonds, on lui demande de les transférer au moyen d’un service de virement télégraphique. L’employé, à titre d’agent de transfert, reçoit comme paiement un pourcentage des fonds. Il s’agit souvent d’une couverture pour des activités illégales.'));
      this.updateChatbotState(handleEtransferSecurityOptions3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleEtransferSecurityOptions4 = () => {
      const handleEtransferSecurityOptions4 = this.createChatBotMessage('Vous pouvez recevoir des ententes d’embauche, des sites Web et d’autres types de renseignements officiels. Bien que ces sites Web et ces ententes d’embauche semblent légitimes, ce n’est souvent pas le cas.');
      this.updateChatbotState(handleEtransferSecurityOptions4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleSupport = () => {
      const message = this.createChatBotMessage(
        'Comment pouvons-nous offrir de l\'aide?',
        {
          widget: 'EtransferSupport',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleDebit = () => {
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'DebitOptions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleContactlessPayments = () => {
      //window.open('https://www.interac.ca/en/consumers/products/interac-debit/interac-flash/', '_blank');
      const user_message = this.createChatBotMessage(
        'Contactless Payments',
      );
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'ContactlessPaymentsOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleContactlessPayments1 = () => {
      const handleContactlessPayments1 = this.createChatBotMessage(parse('Les transactions par Débit <em>Interac</em> et Flash <em>Interac</em> sont approuvées par votre banque ou coopérative de crédit en temps réel au moyen de systèmes sécurisés en ligne. Les transactions apparaissent instantanément dans votre dossier de compte bancaire, ce qui vous permet de surveiller votre solde disponible et de suivre vos dépenses.'));
      this.updateChatbotState(handleContactlessPayments1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleContactlessPayments2 = () => {
      const handleContactlessPayments2 = this.createChatBotMessage(parse('La sécurité est importante pour nous. Les cartes à puce Débit <em>Interac</em> et Flash <em>Interac</em> sont extrêmement sûres et protégées contre les tactiques frauduleuses comme le clonage, la copie ou le vol à la tire électronique. Lorsque vous effectuez un paiement, les seules données transmises sont des codes de transaction de paiement, et non des renseignements confidentiels relatifs à votre compte bancaire. Étant donné que les transactions ont lieu en temps réel, aucun renseignement ne peut être intercepté par des criminels qui voudraient faire des transactions frauduleuses ou commettre un vol d’identité.'));
      this.updateChatbotState(handleContactlessPayments2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleContactlessPayments3 = () => {
      const handleContactlessPayments3 = this.createChatBotMessage(parse('Débit <em>Interac</em> et Flash <em>Interac</em> sont des modes de paiement extrêmement sécuritaires et assortis de mesures de protection et d’outils de détection de la fraude sophistiqués pour vous protéger :<ul><li>Les cartes de débit Interac sont dotées de puces qui répondent à la norme EMV afin de stocker et de traiter des données de façon sécuritaire. Cette technologie rend la contrefaçon de cartes pratiquement impossible et vous protège contre les tactiques frauduleuses, comme le clonage, la réexécution de transactions ou le vol à la tire électronique.</li><li>Lorsque vous utilisez Débit <em>Interac</em> sur votre appareil mobile, vous bénéficiez des mêmes caractéristiques de sécurité que lorsque vous utilisez votre carte de débit Interac ainsi que des mesures de sécurité normalisées de votre appareil, comme le mot de passe ou l’authentification biométrique.</li></ul>Les limites de transaction sont fixées à 100 $ CAD par transaction.  Une limite cumulative de transactions sans contact établie à l’échelle individuelle par les banques ou les coopératives de crédit offre une protection supplémentaire.  La limite cumulative est la limite maximale de transactions sans contact qui peuvent être effectuées au moyen d’une même carte Débit <em>Interac</em> avant que l’utilisateur soit appelé à réinitialiser la limite avec une transaction à puce avec un NIP. Vous confirmez ainsi que vous êtes le titulaire autorisé.</br />De plus, vous êtes également protégé contre toute perte attribuable à des transactions non autorisées en vertu de la Politique zéro responsabilité Interac. Si votre carte est perdue ou volée, communiquez immédiatement avec votre banque ou coopérative de crédit.'));
      this.updateChatbotState(handleContactlessPayments3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleContactlessPayments4 = () => {
      const handleContactlessPayments4 = this.createChatBotMessage(parse('Bien qu’il y ait de nombreuses mesures de protection en vigueur, vous jouez également un rôle important pour vous protéger contre la fraude en tant que titulaire d’une carte de débit Interac : <ul><li>Vous devez être la seule personne à utiliser votre carte de débit Interac ou votre appareil mobile pour effectuer des achats.</li><li>Choisissez un NIP difficile à deviner pour les autres, en évitant les numéros évidents comme votre numéro de téléphone ou votre date de naissance, et ne le communiquez à personne. </li></li>Vérifiez régulièrement vos relevés bancaires et signalez immédiatement toute activité inhabituelle à votre banque ou coopérative de crédit.</li><li>Si votre carte est perdue ou volée, communiquez immédiatement avec votre banque ou coopérative de crédit.</li></ul>'));
      this.updateChatbotState(handleContactlessPayments4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleTransitOpenPayments = () => {
      const user_message = this.createChatBotMessage(
        'Les paiements ouverts pour les transports en commun',
      );
      const message = this.createChatBotMessage(
        'Au sujet de quel produit pouvons-nous vous aider?',
        {
          widget: 'TransitOpenPaymentsOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };
    handleTransit1 = () => {
      const handleTransit1 = this.createChatBotMessage(parse('Les systèmes de paiement ouverts pour les transports en commun permettent aux usagers d\'acheter des titres de transport en tapant une carte de paiement, ou un portefeuille mobile, sur un lecteur de titres, et ce, sans avoir à utiliser de carte de transport en commun ou d’application de transport en commun pour payer leur titre. À cette fin, Interac permet l’utilisation d’une carte de débit ou d’un portefeuille mobile accepté par Débit <em>Interac</em><sup>MD</sup>. '));
      this.updateChatbotState(handleTransit1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit2 = () => {
      const handleTransit2 = this.createChatBotMessage(parse('<p>Metrolinx offre la possibilité de payer pour les transports en commun directement par Débit <em>Interac</em> à bord de l’Union Pearson Express de Toronto et de TransLink à Vancouver. D’autres sociétés de transport en commun dans la région du Grand Toronto et de Hamilton ont récemment été ajoutées, notamment GO Transit, Brampton Transit, Burlington Transit, Durham Region Transit, Hamilton Street Railway, MiWay à Mississauga, Oakville Transit, York Region Transit et Para Transpo à Ottawa, et d’autres à venir.</p>'));
      this.updateChatbotState(handleTransit2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit3 = () => {
      const handleTransit3 = this.createChatBotMessage(parse('<p>Bien que de nombreuses grandes villes dans le monde aient déployé ce type de système, les plans de mise en œuvre reposent sur les sociétés de transport, les municipalités et les organismes gouvernementaux. Interac explore la possibilité des systèmes de paiement ouverts pour les transports en commun avec un certain nombre de sociétés de transport au Canada.</p><p>Pour en savoir plus sur la disponibilité des systèmes de paiement ouverts pour les transports en commun dans votre région, communiquez avec votre société de transport locale.</p>'));
      this.updateChatbotState(handleTransit3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit4 = () => {
      const handleTransit4 = this.createChatBotMessage(parse('C’est à la discrétion de la société de transport, des municipalités desservies ou des organismes gouvernementaux associés de déterminer les options de paiement qui sont offertes aux utilisateurs du réseau de transport en commun. Pour en savoir plus, veuillez communiquer avec la société de transport de votre région.'));
      this.updateChatbotState(handleTransit4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit5 = () => {
      const handleTransit5 = this.createChatBotMessage(parse('<p>Lorsque vous utiliserez Débit <em>Interac</em>, le prix du voyage variera selon vos déplacements.</p></p>À bord de GO Transit et d’UP Express, le tarif sera basé sur la distance. Lorsque les clients paient par Débit <em>Interac</em> sur GO Transit ou UP Express, ils doivent payer un montant temporaire préautorisé qui peut être supérieur au coût prévu du déplacement. Les clients doivent s’assurer d’avoir suffisamment de fonds dans leur carte de débit Interac pour couvrir le tarif préautorisé.</p><p>La différence entre le tarif exact et le montant préautorisé est remise par votre banque.</p></p>Dans l’ensemble des 905 réseaux de transport en commun de la région du Grand Toronto et de Hamilton participant au programme, un tarif fixe sera facturé aux clients.</p>'));
      this.updateChatbotState(handleTransit5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit6 = () => {
      const handleTransit6 = this.createChatBotMessage(parse('Vous pouvez communiquer directement avec la société de transport pour lui poser des questions sur les paiements par Débit <em>Interac</em>.'));
      this.updateChatbotState(handleTransit6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit7 = () => {
      const handleTransit7 = this.createChatBotMessage(parse('<p>Pour payer votre titre et accéder au réseau de transport en commun, vous n’avez qu’à taper votre justificatif de paiement (p. ex., carte de débit, portefeuille mobile) sur le lecteur de titre de transport.</p><p>Les sociétés de transport peuvent utiliser un modèle de paiement à tarif fixe ou à tarif variable (p. ex., en fonction de la distance parcourue ou du temps). Pour chaque modèle de paiement, les règles qui s’appliquent aux clients par rapport à l’accès au réseau de transport en commun ou aux correspondances varient d’une société de transport à l’autre. Pour obtenir de plus amples renseignements, veuillez communiquer avec votre société de transport locale. La société de transport calculera automatiquement le tarif et le portera à votre compte par l’intermédiaire de votre institution financière, normalement le jour même ou le lendemain.</p>'));
      this.updateChatbotState(handleTransit7);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleecommercePayments = () => {
      const user_message = this.createChatBotMessage(
        'e-Commerce Payments',
      );
      const message = this.createChatBotMessage(
        'Au sujet de quel produit pouvons-nous vous aider?',
        {
          widget: 'EcommercePaymentsOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleApplePay = () => {
      const user_message = this.createChatBotMessage(
        'Apple Pay',
      );
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'ApplePayOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleApplePay1 = () => {
      const handleApplePay1 = this.createChatBotMessage(parse('Le service Débit <em>Interac</em> avec Apple Pay est une nouvelle façon d’effectuer des paiements par Débit <em>Interac</em> au moyen de votre appareil Apple admissible. Le service de paiements Débit <em>Interac</em> intégré aux applications et aux navigateurs est la façon simple, rapide et sécuritaire que les Canadiens peuvent utiliser pour régler leurs achats directement à partir de leur compte bancaire lorsqu’ils magasinent en ligne sur leur appareil mobile. Les paiements intégrés aux applications sont effectués à partir de l’application mobile du commerçant. Les paiements intégrés aux navigateurs sont effectués à partir d’un navigateur mobile compatible (p. ex., Safari).'));
      this.updateChatbotState(handleApplePay1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleApplePay2 = () => {
      const handleApplePay2 = this.createChatBotMessage(parse('Les titulaires d’une carte de débit <em>Interac</em> émise par une institution financière participante peuvent utiliser Débit <em>Interac</em> pour payer avec Apple Pay auprès des commerçants qui acceptent les paiements sans contact Flash <em>Interac</em>. For eCommerce transactions through <em>Interac Debit</em> with Apple Pay, <em>Interac</em> debit cardholders with a debit card issued from participating financial institutions can pay on select merchant applications or mobile websites using Apple Pay. We are continuously working to onboard more issuers and merchants to support through Interac Debit with Apple Pay.'));
      this.updateChatbotState(handleApplePay2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleApplePay3 = () => {
      const handleApplePay3 = this.createChatBotMessage(parse('Les cartes de débit Interac émises par les institutions financières participantes peuvent être ajoutées à Apple Pay. Pour obtenir des précisions, veuillez communiquer avec votre institution financière. Pour les transactions effectuées dans une application ou un navigateur, une carte de débit Interac émise par une institution financière participante doit d’abord être liée à l’appareil Apple (dans le portefeuille mobile) avant de pouvoir être utilisée dans l’application ou sur le site Web mobile d’un commerçant participant. Pour en savoir plus sur l’utilisation d’Apple Pay ou consulter une liste des appareils Apple pris en charge (iPhone, iPad, Apple Watch ou Mac), veuillez visiter le site <a href="https://www.apple.com/ca/fr/apple-pay/">apple.com/ca/fr/apple-pay</a>.'));
      this.updateChatbotState(handleApplePay3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleApplePay4 = () => {
      const handleApplePay4 = this.createChatBotMessage(parse('Ous pouvez utiliser Débit <em>Interac</em> avec Apple Pay pour effectuer des paiements avec un appareil pris en charge auprès de tous les commerçants acceptant les paiements Flash <em>Interac</em>. Recherchez simplement le logo Flash <em>Interac</em> ou le symbole de paiement sans contact à la caisse. Vous pouvez également utiliser Débit <em>Interac</em> avec Apple Pay pour les transactions effectuées dans une application ou un navigateur afin d’effectuer un achat dans l’application mobile ou sur le site Web mobile de commerçants sélectionnés qui ont intégré Apple Pay. Nous travaillons continuellement à ajouter davantage d’émetteurs et de commerçants qui prennent en charge la fonction de paiement intégré aux applications et aux navigateurs avec Débit <em>Interac</em>.'));
      this.updateChatbotState(handleApplePay4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleApplePay5 = () => {
      const handleApplePay5 = this.createChatBotMessage(parse('Pour obtenir des directives sur la façon d’ajouter une carte de débit <em>Interac</em> à un portefeuille mobile, veuillez visiter la page Apple Pay <em>Interac</em>. Votre carte de débit ne sera acceptée comme mode de paiement que si votre institution financière compte parmi les émetteurs participants. Remarque : Pour effectuer des transactions Débit <em>Interac</em> dans une application ou sur le site Web mobile d’un commerçant, vous devrez d’abord lier votre carte de débit <em>Interac</em> à votre portefeuille Apple Pay.'));
      this.updateChatbotState(handleApplePay5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGooglePay = () => {
      const user_message = this.createChatBotMessage(
        'Google Pay',
      );
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'GooglePayOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };
    handleGooglePay1 = () => {
      const handleGooglePay1 = this.createChatBotMessage(parse('Le service Débit <em>Interac</em> avec Google Pay est une façon d’effectuer facilement des paiements par débit au moyen de votre appareil Android admissible. Le service de paiements Débit <em>Interac</em> intégré aux applications et aux navigateurs est la façon simple, rapide et sécuritaire que les Canadiens peuvent utiliser pour régler leurs achats directement à partir de leur compte bancaire lorsqu’ils magasinent en ligne sur leur appareil mobile. Les paiements intégrés aux applications sont effectués à partir de l’application mobile du commerçant. Les paiements intégrés aux navigateurs sont effectués à partir d’un navigateur mobile compatible (p. ex., Chrome).'));
      this.updateChatbotState(handleGooglePay1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGooglePay2 = () => {
      const handleGooglePay2 = this.createChatBotMessage(parse('Les titulaires d’une carte de débit <em>Interac</em> émise par une institution financière participante peuvent utiliser Débit <em>Interac</em> pour payer avec Google Pay auprès des commerçants qui acceptent les paiements sans contact Flash <em>Interac</em>.'));
      this.updateChatbotState(handleGooglePay2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGooglePay3 = () => {
      const handleGooglePay3 = this.createChatBotMessage(parse('Les cartes de débit Interac émises par les institutions financières participantes peuvent être ajoutées à Google Pay. Pour obtenir des précisions, veuillez communiquer avec votre institution financière. Pour en savoir plus sur l’utilisation de Google Pay ou consulter une liste des appareils Android pris en charge, veuillez visiter le site <a href="https://www.android.com/pay/">https://www.android.com/pay/</a>.'));
      this.updateChatbotState(handleGooglePay3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGooglePay4 = () => {
      const handleGooglePay4 = this.createChatBotMessage('Google Pay est préchargé sur certains appareils Google. Si l’application n’est pas déjà dans votre appareil, il suffit de la télécharger dans le Play Store de Google.');
      this.updateChatbotState(handleGooglePay4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGooglePay5 = () => {
      const handleGooglePay5 = this.createChatBotMessage(parse('Ce message signifie que Google n’a pas encore mis à jour votre appareil, ce qui vous empêche d’y ajouter votre carte de débit. Google vous enverra un courriel et vous recevrez une notification sur votre appareil lorsqu’il aura été mis à jour. Vous pourrez alors ajouter votre carte de débit émise par une institution financière participante et utiliser Débit Interac avec Google Pay.'));
      this.updateChatbotState(handleGooglePay5);
      
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleSamsungPay = () => {
      const user_message = this.createChatBotMessage(
        'Samsung Pay',
      );
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'SamsungPayOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleSamsungPay1 = () => {
      const handleSamsungPay1 = this.createChatBotMessage(parse('Débit Interac avec Samsung Pay est un moyen facile d’effectuer des paiements mobiles sans contact rapides et sécuritaires à l’aide de Samsung Pay, offert aux consommateurs titulaires de cartes de débit Interac émises par les institutions financières participantes.'));
      this.updateChatbotState(handleSamsungPay1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleSamsungPay2 = () => {
      const handleSamsungPay2 = this.createChatBotMessage(parse('Les Canadiens titulaires d’une carte de débit <em>Interac</em> admissible émise par une institution financière participante peuvent désormais utiliser celle-ci avec Samsung Pay pour régler leurs achats dans les commerces qui acceptent les paiements sans contact Flash <em>Interac</em>.'));
      this.updateChatbotState(handleSamsungPay2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleSamsungPay3 = () => {
      const handleSamsungPay3 = this.createChatBotMessage(parse('Pour l’instant, les cartes de débit <em>Interac</em> émises par les institutions financières canadiennes participantes peuvent être ajoutées à Samsung Pay. Pour obtenir des précisions, veuillez communiquer avec votre institution financière. Samsung Pay fonctionne avec la plupart des appareils Samsung dotés de la fonction de communication NFC; cliquez ici pour obtenir une liste des appareils pris en charge ainsi que les exigences logicielles . Les appareils dotés de la fonction de communication NFC vous permettent d’effectuer des achats chez les commerçants qui affichent l’un des symboles suivants à la caisse.'));
      this.updateChatbotState(handleSamsungPay3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleSamsungPay4 = () => {
      const handleSamsungPay4 = this.createChatBotMessage(parse('Vous pouvez obtenir l’application Samsung Pay en la téléchargeant à partir de Samsung Galaxy Apps.'));
      this.updateChatbotState(handleSamsungPay4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleSamsungPay5 = () => {
      const handleSamsungPay5 = this.createChatBotMessage(parse('Pour ajouter une carte de Débit <em>Interac</em> d’une institution financière participante à Samsung Pay, ouvrez l’application Samsung Pay sur votre appareil admissible, puis ouvrez une session dans votre compte Samsung. Entrez un NIP afin de pouvoir autoriser vos prochains achats. Utilisez l’appareil photo du téléphone pour reconnaître votre carte de débit <em>Interac</em> ou entrez les renseignements sur la carte manuellement. Ensuite, entrez tout autre renseignement, s’il y a lieu. Pour des raisons de sécurité, une étape de vérification pourrait être exigée afin d’activer votre carte virtuelle. Si vous possédez une carte mixte (logo Interac et autres logos de marque de paiement par débit au recto de la carte bancaire), vous devrez saisir votre code de sécurité (CVV) et accepter les conditions d’utilisation de votre institution financière pour Samsung Pay lorsque vous ajouterez la carte à Samsung Pay. Vous pourriez aussi être assujetti à d’autres modalités propres à votre institution financière ou à Samsung.'));
      this.updateChatbotState(handleSamsungPay5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleOnlinePayments = () => {
      const user_message = this.createChatBotMessage(
        'Samsung Pay',
      );
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'OnlinePaymentsOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleOnlinePayments1 = () => {
      const handleOnlinePayments1 = this.createChatBotMessage(parse('Veuillez communiquer avec votre banque ou coopérative de crédit pour obtenir du soutien relativement à toute transaction. Les coordonnées figurent habituellement au verso de votre carte de débit Interac.'));
      this.updateChatbotState(handleOnlinePayments1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePayments2 = () => {
      const handleOnlinePayments2 = this.createChatBotMessage('Veuillez communiquer avec votre banque ou coopérative de crédit pour vous renseigner sur les limites.');
      this.updateChatbotState(handleOnlinePayments2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePayments3 = () => {
      const handleOnlinePayments3 = this.createChatBotMessage(parse('Votre paiement <em>Interac</em> en ligne est traité par votre banque ou coopérative de crédit, qui s’occupera de facturer des frais s’il y a lieu. Pour en savoir plus, communiquez avec votre banque ou coopérative de crédit.'));
      this.updateChatbotState(handleOnlinePayments3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePayments4 = () => {
      const handleOnlinePayments4 = this.createChatBotMessage('Il est facile d’avoir accès aux services bancaires en ligne. Votre banque ou coopérative de crédit peut vous aider. Visitez le site Web de votre banque ou coopérative de crédit pour vous inscrire ou communiquez directement avec votre banque ou coopérative de crédit pour en savoir plus.');
      this.updateChatbotState(handleOnlinePayments4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePayments5 = () => {
      const handleOnlinePayments5 = this.createChatBotMessage(parse('Pour toute question relative à vos achats en ligne (temps de livraison, options d’expédition, renseignements sur le produit, etc.), veuillez communiquer avec le commerçant. Pour toute question ou préoccupation relative à votre paiement Interac en ligne à laquelle le commerçant ne peut répondre (frais, limites, compte bancaire, délai de traitement, etc.), veuillez communiquer avec votre banque.'));
      this.updateChatbotState(handleOnlinePayments5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePayments6 = () => {
      const handleOnlinePayments6 = this.createChatBotMessage(parse('Si la page de confirmation s’affiche et si vous recevez un numéro de confirmation, votre paiement a été traité. Par contre, si le navigateur ne vous redirige pas à la page de confirmation du site du commerçant après la confirmation de votre paiement sur le site des services bancaires en ligne, c’est que l’une des deux situations ci-dessous est survenue : <ol><li>Le commerçant a reçu votre paiement, mais, pour une raison quelconque, la page de confirmation ne s’affiche pas. Si vous recevez un courriel de confirmation ou si vous pouvez voir la transaction dans l’historique de vos commandes sur le site Web du détaillant, c’est probablement le cas.</li><li>Le commerçant n’a pu recevoir votre paiement. Le cas échéant, votre paiement sera crédité à votre compte dans quelques minutes.</li></ol>Vous pouvez également communiquer avec le détaillant en ligne pour confirmer le traitement de votre commande.'));
      this.updateChatbotState(handleOnlinePayments6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleAbmWithdrawals = () => {
      const user_message = this.createChatBotMessage(
        'Retraits en espèces',
      );
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'AbmWithdrawalsOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleAbmWithdrawals1 = () => {
      const handleAbmWithdrawals1 = this.createChatBotMessage(parse('Comptant <em>Interac</em> est une façon pratique de retirer de l’argent de votre compte au moyen de n’importe quel guichet automatique bancaire (GAB) sur lequel figure le logo Interac, n’importe où au Canada. Interac a rendu possible l’accès à votre compte pour effectuer des retraits en toute commodité à plus de 70 000 GAB partout au Canada, dont un grand nombre sont accessibles en tout temps.'));
      this.updateChatbotState(handleAbmWithdrawals1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAbmWithdrawals2 = () => {
      const handleAbmWithdrawals2 = this.createChatBotMessage(parse('Veuillez communiquer avec votre banque ou coopérative de crédit pour obtenir du soutien relativement à toute transaction à un GAB. Les coordonnées figurent habituellement au verso de votre carte de débit <em>Interac</em>.'));
      this.updateChatbotState(handleAbmWithdrawals2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAbmWithdrawals3 = () => {
      const handleAbmWithdrawals3 = this.createChatBotMessage(parse('Comptant Interac est sécuritaire, car vous vous servez de votre carte à puce et de votre numéro d’identification personnel (NIP) confidentiel. Tous les participants au réseau Interac sont tenus d’adhérer à des normes de sécurité canadiennes et internationales strictes. Une carte de débit Interac ne peut pas être utilisée pour retirer de l’argent comptant dans un guichet automatique sans le NIP du titulaire. Ainsi, les fonds sont en sécurité même si la carte est volée, perdue ou copiée illégalement. Il est important de signaler immédiatement la perte ou le vol de vos cartes à votre banque ou coopérative de crédit afin d’éviter tout problème de responsabilité.'));
      this.updateChatbotState(handleAbmWithdrawals3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAbmWithdrawals4 = () => {
      const handleAbmWithdrawals4 = this.createChatBotMessage(parse('Le service Comptant Interac vous permet de retirer de l’argent de votre compte à un GAB. Pour commencer une transaction, insérez une carte de débit Interac valide dans un guichet automatique portant le logo Interac et suivez les instructions affichées à l’écran : <ul><li>Entrer le montant à retirer</li><li>Sélectionner le compte à débiter</li>Sélectionner le compte à débiter<li>Composer votre numéro d’identification personnel (NIP)</li><li>Accepter la transaction avant son acheminement pour approbation</li></ul>'));
      this.updateChatbotState(handleAbmWithdrawals4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleDebitSupport = () => {
      const message = this.createChatBotMessage(
        'Comment pouvons-nous offrir de l\'aide?',
        {
          widget: 'DebitSupport',
        }
      );
  
      this.updateChatbotState(message);
    };


    handleBusinessProducts = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'BusinessProducts',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleEtransferBus = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'EtransferOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    handleEufBus = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'EufOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleEtransferBus1 = () => {
      const handleEtransferBus1 = this.createChatBotMessage('Veuillez communiquer avec la banque ou la coopérative de crédit de votre entreprise pour obtenir du soutien et résoudre un problème.');
      this.updateChatbotState(handleEtransferBus1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransferBus2 = () => {
      const handleEtransferBus2 = this.createChatBotMessage(parse('Oui, vous pouvez utiliser Virement <em>Interac</em> pour les besoins de facturation et de paiement de votre entreprise si vous faites affaire avec une banque ou une coopérative de crédit participante. Vous avez besoin d’un compte bancaire canadien en ligne et d’une adresse de courriel ou d’un numéro de téléphone mobile. Si vous envoyez des fonds par Virement <em>Interac</em>, votre destinataire aura également besoin d’une adresse de courriel ou d’un numéro de téléphone mobile canadien pour recevoir les fonds. Veuillez visiter notre page Virement <em>Interac</em> pour les entreprises pour obtenir de plus amples renseignements.'));
      this.updateChatbotState(handleEtransferBus2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransferBus3 = () => {
      const handleEtransferBus3 = this.createChatBotMessage(parse('Les entreprises de toutes tailles peuvent utiliser Virement <em>Interac</em> pour simplifier et accélérer les paiements, des consultants indépendants aux petites et aux grandes entreprises.'));
      this.updateChatbotState(handleEtransferBus3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransferBus4 = () => {
      const handleEtransferBus4 = this.createChatBotMessage('Les frais sont fixés individuellement par les banques et les coopératives de crédit. Veuillez communiquer avec la banque de votre entreprise pour obtenir des renseignements sur les prix.');
      this.updateChatbotState(handleEtransferBus4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    
    handleOurSolutions = () => {
      const message = this.createChatBotMessage(
        'Au sujet de quel produit voulez-vous en savoir plus?',
        {
          widget: 'OurSolutions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleAutodepositBus = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'AutodepositOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    AutodepositBus1 = () => {
      const AutodepositBus1 = this.createChatBotMessage(parse('Vous devez vous inscrire. Visitez notre page Virement <em>Interac</em> pour en savoir plus sur la <a href="https://www.interac.ca/fr/consommateur/produits/virement-interac/fonctions-ameliorees/">configuration de la fonction Dépôt automatique</a>.'));
      this.updateChatbotState(AutodepositBus1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AutodepositBus2 = () => {
      const AutodepositBus2 = this.createChatBotMessage(parse('Visitez <a href="https://www.interac.ca/fr/entreprise/securite/virement-interac/">notre page sur la sécurité de Virement <em>Interac</em> pour les entreprises</a> ou adressez-vous à la banque de votre entreprise. Vous trouverez une liste des banques ou coopératives de crédit offrant la fonction de dépôt automatique sur notre page Virement <em>Interac</em>.'));
      this.updateChatbotState(AutodepositBus2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AutodepositBus3 = () => {
      const AutodepositBus3 = this.createChatBotMessage(parse('Le processus est simple. Veuillez visiter notre page Virement <em>Interac</em> pour en savoir plus sur la désactivation de la fonction Dépôt automatique.'));
      this.updateChatbotState(AutodepositBus3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleRequestMoneyBus = () => {
      const message = this.createChatBotMessage(
        'Au sujet de quel produit voulez-vous en savoir plus?',
        {
          widget: 'RequestMoneyOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    RequestMoneyBus = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'RequestMoneyOptionsBus',
        }
    );
  
      this.updateChatbotState(message);
    };
    RequestMoneyBus1 = () => {
      const RequestMoneyBus1 = this.createChatBotMessage(parse('Demander des fonds est une fonction de Virement <em>Interac</em> facile à utiliser qui vous permet d’envoyer un avis à une personne pour lui demander un paiement. Il s’agit d’une façon pratique d’envoyer des factures aux clients et de s’assurer que le paiement est acheminé au bon endroit, ce qui réduit au minimum le risque que votre paiement soit perdu, retardé par la poste ou envoyé vers le mauvais compte.'));
      this.updateChatbotState(RequestMoneyBus1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    RequestMoneyBus2 = () => {
      const RequestMoneyBus2 = this.createChatBotMessage(parse('Vous pouvez ajouter le numéro de facture dans l’espace réservé aux messages lorsque vous envoyez l’avis de Demande de fonds Virement <em>Interac</em> pour lui attribuer une fonction de facture. Veuillez noter que les messages comportent une limite de caractères.'));
      this.updateChatbotState(RequestMoneyBus2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleBulkDisbursements = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'BulkDisbursementsOptions',
        }
    );
  
      this.updateChatbotState(message);
    };
    BulkDisbursements1 = () => {
      const BulkDisbursements1 = this.createChatBotMessage(parse('Le service de décaissement en vrac vous permet d’effectuer plusieurs paiements en même temps par Virement <em>Interac</em>. Il peut contribuer à simplifier votre système de paie et de paiement des fournisseurs. Veuillez visiter notre Virement <em>Interac</em> pour les entreprises pour obtenir de plus amples renseignements sur son fonctionnement.'));
      this.updateChatbotState(BulkDisbursements1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    BulkDisbursements2 = () => {
      const BulkDisbursements2 = this.createChatBotMessage(parse('Les frais sont fixés par votre banque ou votre coopérative de crédit. Veuillez communiquer avec la banque de votre entreprise pour obtenir des renseignements sur les prix. Vous trouverez également une liste des banques ou coopératives de crédit offrant le service de décaissement en vrac sur notre page Virement <em>Interac</em>.'));
      this.updateChatbotState(BulkDisbursements2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    BulkDisbursements3 = () => {
      const BulkDisbursements3 = this.createChatBotMessage('Veuillez communiquer avec votre banque ou coopérative de crédit offrant le service de décaissement en vrac pour obtenir une description détaillée du format et des méthodes de présentation autorisés.');
      this.updateChatbotState(BulkDisbursements3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    BulkDisbursements4 = () => {
      const BulkDisbursements4 = this.createChatBotMessage(parse('The time will vary by bank or credit union; <em>Interac</em> starts processing the payments as soon as we receive them from the financial institution.'));
      this.updateChatbotState(BulkDisbursements4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    BulkDisbursements5 = () => {
      const BulkDisbursements5 = this.createChatBotMessage(parse('Please contact your business bank or credit union. You can also find a list of participating banks and credit unions on our <em>Interac</em> e-Transfer page.'));
      this.updateChatbotState(BulkDisbursements5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleDebitBus = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'DebitOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    DebitBus1 = () => {
      const DebitBus1 = this.createChatBotMessage(parse('Pour obtenir du soutien et résoudre un problème, veuillez communiquer avec votre acquéreur Débit Interac.'));
      this.updateChatbotState(DebitBus1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    DebitBus2 = () => {
      const DebitBus2 = this.createChatBotMessage(parse('Un acquéreur est un fournisseur de services qui offre des terminaux Débit <em>Interac</em> et des services aux entreprises. Veuillez consulter notre page Débit <em>Interac</em> pour les entreprises pour obtenir une <a href="https://www.interac.ca/fr/entreprise/fonctionnement/trouver-un-acquereur/#fi-list-acquirers-interac-debit-service-pos-merchant-services">liste des acquéreurs participants</a>.'));
      this.updateChatbotState(DebitBus2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    DebitBus3 = () => {
      const DebitBus3 = this.createChatBotMessage(parse('<em>Interac</em> est un mode de paiement qui convient à toutes les entreprises au Canada, peu importe leur taille.'));
      this.updateChatbotState(DebitBus3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    DebitBus4 = () => {
      const DebitBus4 = this.createChatBotMessage(parse('Vous pouvez obtenir un terminal de point de vente Débit <em>Interac</em> par l’entremise d’un acquéreur. Les acquéreurs gèrent tous les services liés à Débit <em>Interac</em>. Vous trouverez une liste des acquéreurs participants sur notre page Débit <em>Interac</em> pour les entreprises.'));
      this.updateChatbotState(DebitBus4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    DebitBus5 = () => {
      const DebitBus5 = this.createChatBotMessage(parse('Les frais sont fixés par l’acquéreur que vous choisissez, y compris les frais pour les services <em>Interac</em>. Pour de plus amples renseignements, veuillez visiter notre page Comprendre les frais. Pour communiquer avec un acquéreur et obtenir de plus amples renseignements sur les frais, vous pouvez consulter une liste des acquéreurs participants sur notre page Débit <em>Interac</em> pour les entreprises.'));
      this.updateChatbotState(DebitBus5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    DebitBus6 = () => {
      const DebitBus6 = this.createChatBotMessage(parse('Le temps et le processus d’installation peuvent varier d’un acquéreur à l’autre. Veuillez consulter notre page Débit <em>Interac</em> pour les entreprises pour obtenir une liste des acquéreurs participants.'));
      this.updateChatbotState(DebitBus6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleContactlessBus = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'ContactlessOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    ContactlessBus1 = () => {
      const ContactlessBus1 = this.createChatBotMessage(parse('Pour obtenir du soutien et résoudre un problème, veuillez communiquer avec votre acquéreur paiements sans contact.'));
      this.updateChatbotState(ContactlessBus1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    ContactlessBus2 = () => {
      const ContactlessBus2 = this.createChatBotMessage(parse('Les paiements sans contact et par puce et NIP par Débit <em>Interac</em> sont approuvés par votre banque ou coopérative de crédit en temps réel au moyen de systèmes sécurisés en ligne. Les transactions apparaissent instantanément dans votre dossier de compte bancaire, ce qui vous permet de surveiller votre solde disponible et de suivre vos dépenses.'));
      this.updateChatbotState(ContactlessBus2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    ContactlessBus3 = () => {
      const ContactlessBus3 = this.createChatBotMessage(parse('La réponse dépend du type de terminal que vous avez actuellement. La majorité des terminaux sur le marché sont compatibles avec Flash <em>Interac</em>. Veuillez communiquer avec votre acquéreur pour vérifier si votre terminal est compatible avec Flash <em>Interac</em>.'));
      this.updateChatbotState(ContactlessBus3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    ContactlessBus4 = () => {
      const ContactlessBus4 = this.createChatBotMessage(parse('Les frais sont fixés par l’acquéreur que vous choisissez, y compris les frais pour les services Interac. Pour de plus amples renseignements, veuillez visiter notre page <a href="http://stage.interac.ca/fr/entreprise/soutien/comprendre-les-frais/">Comprendre les frais</a>. Pour communiquer avec un acquéreur et obtenir de plus amples renseignements sur les frais, vous pouvez consulter une <a href="http://stage.interac.ca/fr/entreprise/fonctionnement/trouver-un-acquereur/">liste des acquéreurs</a> participants sur notre page Débit <em>Interac</em> pour les entreprises.'));
      this.updateChatbotState(ContactlessBus4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    ContactlessBus5 = () => {
      const ContactlessBus5 = this.createChatBotMessage(parse('Veuillez consulter notre page sur la sécurité de Flash <em>Interac</em> pour les entreprises pour obtenir de plus amples renseignement sur la sécurité et les protections comme la Politique zéro responsabilité Interac.'));
      this.updateChatbotState(ContactlessBus5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    ContactlessBus6 = () => {
      const ContactlessBus6 = this.createChatBotMessage(parse('Please see our Contactless Payments for Business <a href="https://www.interac.ca/en/business/safety-and-security/interac-debit/">security page</a> for information around security and protections such as the <em>Interac</em> Zero Liability Policy.'));
      this.updateChatbotState(ContactlessBus6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleMobileBus = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'MobileOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    MobileBus1 = () => {
      const MobileBus1 = this.createChatBotMessage(parse('Les paiements sans contact par Débit <em>Interac</em> sont une solution de paiement au point de vente qui fonctionne avec Apple Pay, Google Pay et Samsung Pay. Pour en savoir plus sur son fonctionnement et pour trouver une liste d’acquéreurs participants, veuillez visiter notre page sur les paiements sans contact par Débit <em>Interac</em> pour les entreprises.'));
      this.updateChatbotState(MobileBus1);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    MobileBus2 = () => {
      const MobileBus2 = this.createChatBotMessage(parse('Si vous offrez déjà Flash <em>Interac</em> à vos clients, aucune configuration supplémentaire n’est requise.  Pour en savoir plus, adressez-vous à votre acquéreur. Vous trouverez également une <a href="http://stage.interac.ca/fr/entreprise/fonctionnement/trouver-un-acquereur/">liste d’acquéreurs participants</a> sur notre page Débit <em>Interac</em> sur appareil mobile pour les entreprises.'));
      this.updateChatbotState(MobileBus2);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    MobileBus3 = () => {
      const MobileBus3 = this.createChatBotMessage(parse('Pour obtenir du soutien et résoudre un problème, veuillez communiquer avec votre acquéreur Débit Interac.'));
      this.updateChatbotState(MobileBus3);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePaymentsBus = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'OnlineOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    OnlineBus1 = () => {
      const OnlineBus1 = this.createChatBotMessage(parse('Pour obtenir du soutien et résoudre un problème, veuillez communiquer avec l’institution financière qui vous offre le service Interac en ligne.'));
      this.updateChatbotState(OnlineBus1);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    OnlineBus2 = () => {
      const OnlineBus2 = this.createChatBotMessage(parse('<em>Interac</em> en ligne est un système de paiement sécurisé pour le commerce électronique au Canada. Lorsqu’un client passe à la caisse, une nouvelle fenêtre de navigateur s’ouvre pour le diriger vers son compte bancaire en ligne. Ainsi, le commerçant ne traite jamais de renseignements confidentiels. Visitez notre page <em>Interac</em> en ligne pour en savoir plus sur son fonctionnement.'));
      this.updateChatbotState(OnlineBus2);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    OnlineBus3 = () => {
      const OnlineBus3 = this.createChatBotMessage(parse('Pour utiliser le service <em>Interac</em>  en ligne, le client doit être inscrit aux services bancaires en ligne.'));
      this.updateChatbotState(OnlineBus3);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    OnlineBus4 = () => {
      const OnlineBus4 = this.createChatBotMessage(parse('La séparation entre le processus d’établissement de la commande et celui de règlement constitue l’un des principaux avantages que présente le service Interac en ligne. Le client est amené sur le site de ses services bancaires en ligne pour payer. Ainsi, il n’a pas à entrer de renseignements confidentiels sur son compte sur votre site Web. Des études révèlent que les clients sont réticents à transmettre des renseignements financiers aux commerçants en ligne. Une fois qu’un paiement est effectué par Interac en ligne, le navigateur redirige automatiquement le client vers votre site Web. Si le client n’est pas en mesure d’autoriser le paiement par l’intermédiaire des services bancaires en ligne ou décide de ne pas le faire, il sera quand même redirigé vers votre site Web, ce qui vous permettra de lui proposer un autre mode de paiement.'));
      this.updateChatbotState(OnlineBus4);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    OnlineBus5 = () => {
      const OnlineBus5 = this.createChatBotMessage(parse('Certains acquéreurs et fournisseurs de services de paiement permettent les remboursements avec Interac en ligne. Vous pouvez ainsi créditer le remboursement dans le compte bancaire que le client a utilisé pour l’achat. La politique de remboursement est à votre discrétion. Vous avez toujours la possibilité d’utiliser d’autres modes de remboursement (p. ex., note de crédit ou chèque).'));
      this.updateChatbotState(OnlineBus5);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    OnlineBus6 = () => {
      const OnlineBus6 = this.createChatBotMessage(parse('Les transactions par carte de crédit qui ont été autorisées peuvent donner lieu à une contrepassation. Par exemple, une transaction peut être contestée par un client parce qu’elle a frauduleusement été portée à son compte. Pour éviter les rétrofacturation, les commerçants effectuent souvent des vérifications avant d’accepter les transactions et les refusent si elles semblent suspectes. Toutefois, une transaction qui semble suspecte peut s’avérer légitime. Cette pratique a pour conséquence d’empêcher les clients de régler leurs achats. Interac n’utilise pas et n’impose pas de rétrofacturation. La banque ou la coopérative de crédit du client autorise et garantit chaque paiement.'));
      this.updateChatbotState(OnlineBus6);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleABMBus = () => {
      const message = this.createChatBotMessage(
        'Que pouvons-nous faire pour vous aider?',
        {
          widget: 'AbmOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    AbmBus1 = () => {
      const AbmBus1 = this.createChatBotMessage(parse('Comptant <em>Interac</em> est une façon pratique de retirer de l’argent de votre compte au moyen de n’importe quel guichet automatique bancaire (GAB) sur lequel figure le logo <em>Interac</em>, n’importe où au Canada. <em>Interac</em> a rendu possible l’accès à votre compte pour effectuer des retraits en toute commodité à plus de 70 000 GAB partout au Canada, dont un grand nombre sont accessibles en tout temps.'));
      this.updateChatbotState(AbmBus1);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AbmBus2 = () => {
      const AbmBus2 = this.createChatBotMessage(parse('La présence d’un GAB peut accroître l’achalandage dans votre établissement et faire connaître davantage votre entreprise et ses biens ou services.'));
      this.updateChatbotState(AbmBus2);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AbmBus3 = () => {
      const AbmBus3 = this.createChatBotMessage(parse('Un acquéreur peut vous aider à répondre à cette question. Veuillez visiter notre page Comptant Interac pour les entreprises pour trouver une liste de tous les acquéreurs participants.'));
      this.updateChatbotState(AbmBus3);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AbmBus4 = () => {
      const AbmBus4 = this.createChatBotMessage(parse('La banque du client qui a émis la carte de débit Interacf s’occupera de tous les cas de fraude. Toutefois, vous devez vous assurer de suivre en tout temps les recommandations et les mesures de sécurité communiquées par votre acquéreur lors de l’installation.'));
      this.updateChatbotState(AbmBus4);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AbmBus5 = () => {
      const AbmBus5 = this.createChatBotMessage(parse('Pour toutes les questions et tous les détails concernant Comptant Interac, veuillez vous adresser à un acquéreur. Vous trouverez une liste de tous les acquéreurs participants sur notre page Comptant Interac.'));
      this.updateChatbotState(AbmBus5);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AbmBus6 = () => {
      const AbmBus6 = this.createChatBotMessage(parse('Pour obtenir du soutien et résoudre un problème, veuillez communiquer avec votre acquéreur Comptant <em>Interac</em>.'));
      this.updateChatbotState(AbmBus6);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je peux faire pour vous aider?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    
    

    handleSafetySecurity = () => {
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'SafetySecurity',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleBusinessSupport = () => {
      const message = this.createChatBotMessage(
        'Comment pouvons-nous offrir de l\'aide?',
        {
          widget: 'BusinessSupport',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleCareers = () => {
      const message = this.createChatBotMessage(
        'Quel genre de question voulez-vous poser?',
        {
          widget: 'Careers',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleFeedback = () => {
      const message = this.createChatBotMessage(
        'Vos commentaires sont toujours les bienvenus. Dites-moi ce que vous avez pensé de mon service aujourd’hui.',
        {
          widget: 'Feedback',
        }
      );
  
      this.updateChatbotState(message);
    };
    handleLikedIt = () => {
      const message = this.createChatBotMessage(
        'Merci pour les commentaires positifs. Comme je cherche toujours à apprendre, dites-moi s’il y a d’autres questions avec lesquelles je peux vous aider.',
      );
  
      this.updateChatbotState(message);
    };
    handleHatedIt = () => {
      const message = this.createChatBotMessage(
        'Désolé de ne pas avoir pu vous aider. Comment puis-je m’améliorer la prochaine fois?',
      );
  
      this.updateChatbotState(message);
    };
    handleSoSo = () => {
      const message = this.createChatBotMessage(
        'Désolé de ne pas avoir pu vous aider. Comment puis-je m’améliorer la prochaine fois?',
      );
  
      this.updateChatbotState(message);
    };
  
    updateChatbotState(message) {
      // NOTICE: This function is set in the constructor, and is passed in from the top level Chatbot component. The setState function here actually manipulates the top level state of the Chatbot, so it's important that we make sure that we preserve the previous state.
  
      this.setState((prevState) => ({
        ...prevState,
        messages: [...prevState.messages, message],
      }));
    }
  }
  
  export default ActionProvider;